import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { getParamUrlByKey } from "../../extra/utils";
import useReducer from "../../library/hooks/useReducer";
import Loading from "./components/Loading";
import Waiting from "./components/Waiting";
import paymentReducer from "./paymentReducer";
import { ShareAltOutlined } from '@ant-design/icons';
import { Tooltip, message } from 'antd';
import Step1 from "./page/step1";
import Step2 from "./page/step2";
import Step3 from "./page/step3";
import Step4 from "./page/step4";

const initialState = {
  currentStep: 0,
  dataStep1: {},
  dataStep2: {},
  loading: false,
  loadingQr: false,
  openConfirm: false,
  openWaiting: false,
  openChooseMethost: false,
  sum: 0,
  openMdlink: false,
  openConfirmPass: false,
  errConfirmPass: "",
};

const renderPage = (
  currentStep,
  { state, dispatch, isApp, smScreen, code }
) => {
  switch (currentStep) {
    case 1:
      return <Step1 {...{ state, dispatch, isApp, smScreen }} />;
    case 2:
      return <Step2 {...{ state, dispatch, isApp }} />;
    case 3:
      return <Step3 {...{ state, dispatch, isApp, code }} />;
    case 4:
      return <Step4 {...{ state, dispatch, isApp, code }} />;
    default:
      return <div></div>;
  }
};

export default function Payment() {
  const code = getParamUrlByKey("code");
  const resultCd = getParamUrlByKey("resultCd");
  // trên URL do đối tác bán sản phẩm trả về
  const waiting = getParamUrlByKey("waiting") || false;
  // trên URL do cổng thanh toán megapay trả về
  const success = resultCd === "00_000";
  const isApp = useMediaQuery("(max-width: 1023px)");
  const smScreen = useMediaQuery("(max-width: 1025px)");

  const [state, dispatch] = useReducer({
    reducer: paymentReducer,
    name: "paymentReducer",
    initialState,
  });

  useEffect(() => {
    if (!resultCd && !waiting) {
      dispatch("initial");
    } else {
      dispatch("openSuccess");
    }
    // !success && !waiting ? dispatch("initial") : dispatch("openSuccess");
  }, []);

  useEffect(() => {
    const handlePageShow = (event) => {
      const navEntries = window.performance?.getEntriesByType?.("navigation");
      const isBackForward =
        event.persisted || (navEntries && navEntries[0]?.type === "back_forward");
      if (isBackForward) {
        dispatch("offLoading");
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleCopy = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();
    // Lọc chỉ 2 param
    ["code", "utm_source"].forEach((key) => {
      if (url.searchParams.has(key)) {
        params.set(key, url.searchParams.get(key));
      }
    });
    const newUrl =
      params.toString().length > 0
        ? `${url.origin}${url.pathname}?${params.toString()}`
        : `${url.origin}${url.pathname}`;

    // Copy vào clipboard
    navigator.clipboard
      .writeText(newUrl + '&utm_medium=share')
      .then(() => message.success("Đã sao chép link thanh toán."))
      .catch((err) => message.error("Copy lỗi:", err));
  };

  const { loading, currentStep, openWaiting } = state;
  return (
    <>
      <Loading loading={loading} />
      <Waiting loading={openWaiting} />
      {renderPage(currentStep, { state, dispatch, isApp, smScreen, code })}
      {
        (+currentStep === 1) &&
        <Tooltip getPopupContainer={(triggerNode) => triggerNode.parentElement} placement="top" title={'Chia Sẻ Thanh Toán'} open={true}>
          <div onClick={() => handleCopy()} style={{ position: 'fixed', right: '12%', bottom: '100px', zIndex: 100 }}>
            <div className="glow-circle" style={{ width: 50, height: 50, borderRadius: '100%', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: "0 4px 15px rgba(226, 109, 44, 0.5)", cursor: 'pointer', border: '0.5px solid #E26D2C' }}>
              <ShareAltOutlined style={{ color: '#1F447E', fontSize: 22 }} />
            </div>
          </div>
        </Tooltip>
      }
    </>
  );
}
